enum UserType {
	Natural = 0,
	Legal = 1
}
export default UserType
